const scrollByKey = new Map<string, number>();

export function inboxScrollMemoryKey(accountId: number | null, folder: string): string {
  return `${accountId ?? 0}:${folder}`;
}

export function getInboxScrollTop(key: string): number | null {
  const value = scrollByKey.get(key);
  return value == null ? null : value;
}

export function setInboxScrollTop(key: string, top: number): void {
  if (!Number.isFinite(top) || top < 0) return;
  scrollByKey.set(key, top);
}

export function clearInboxScrollTop(key: string): void {
  scrollByKey.delete(key);
}
